export default __webpack_public_path__ + "a1abf90dfd72792a577a5a43382bb0e4.woff2";